import {
  Map as ImmutableMap,
} from 'immutable';

/* Constants */
import {TOGGLED_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT} from './searchPaginationConstants';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';
import {FACET_QUERY_PARAM_NAMES} from '../../views/filter/facet/facetConstants';
import {
  SEARCH_MIN_QUERY_LENGTH,
} from './searchConstants';
import {
  PLATFORMS,
  ROUTE_PATHS,
} from '../../core/route/routeConstants';

/* Utils */
import {isApiPaginationLimitExceeded} from '../../common/network/apiUtils';
import {generateFilterApiQueryParams} from '../filter/filterUtils';
import {HTTP_STATUS_CODES} from '../../common/network/httpConstants';
import {canRedirectToFirstPage} from '../../common/pagination/paginationUtils';
import {generateQueryString, generateSearchUrl} from '../../common/url/urlUtils';
import {createImmutableMapFromList} from '../../common/collection/collectionUtils';

function isSearchApiPaginationLimitExceeded(pageNumber, isToggledPageLimitActive = false) {
  return (
    (isToggledPageLimitActive &&
      parseInt(pageNumber) > TOGGLED_SEARCH_PAGINATION_PAGE_NUMBER_LIMIT) ||
    isApiPaginationLimitExceeded(pageNumber)
  );
}

function generateSearchPageFilterQueryParams(visibleSelectedFiltersByFacetMap) {
  let filtersByFacetMapEntries = [];
  if (visibleSelectedFiltersByFacetMap) {
    for (const [facetId, selectedFilterMap] of visibleSelectedFiltersByFacetMap) {
      const filtersByFacetArray = Array.from(selectedFilterMap.values()).
        filter(brand => brand.isAutoApplied === false);

      filtersByFacetMapEntries.push([
        facetId,
        createImmutableMapFromList(filtersByFacetArray),
      ]);
    }
  }

  const filteredSelectedFiltersByFacetMap = ImmutableMap(filtersByFacetMapEntries);
  return generateFilterApiQueryParams(
    filteredSelectedFiltersByFacetMap,
    {
      ignoredFacets: [
        null,
      ],
    },
  );
}

function isSearchQueryParamsCorrectly(queryParams) {
  if (queryParams[FACET_QUERY_PARAM_NAMES.QUERY] &&
    queryParams[FACET_QUERY_PARAM_NAMES.QUERY].length &&
    typeof queryParams[FACET_QUERY_PARAM_NAMES.QUERY].length !== 'undefined' &&
    queryParams[FACET_QUERY_PARAM_NAMES.QUERY].length > SEARCH_MIN_QUERY_LENGTH) {
    return true;
  }
  return false;
}

function checkForSearchPageRedirection(
  searchResponseData,
  currentQueryParams,
) {

  let redirection;

  if (searchResponseData && searchResponseData.redirection && searchResponseData.redirection.url) {
    redirection = {
      ...searchResponseData.redirection,
    };
  } else if (searchResponseData && searchResponseData.data && searchResponseData.data.products.length === 0 && !canRedirectToFirstPage(currentQueryParams)) {
    redirection = {
      isInternal: true,
      type: HTTP_STATUS_CODES.MOVED_PERMANENTLY,
      url: generateSearchPageUrl(
        {
          ...currentQueryParams,
          [PAGINATION_PARAM_NAMES.PAGE]: null,
        },
      ),
    };
  } else if (!searchResponseData) {
    redirection = {
      isInternal: true,
      type: HTTP_STATUS_CODES.MOVED_PERMANENTLY,
      url: '/',
    };
  }
  return redirection;
}

function generateSearchPageUrl(queryParams) {
  let url = `${ROUTE_PATHS[PLATFORMS.MOBILE].SEARCH_PAGE}?`;
  if (queryParams) {
    const queryString = generateSearchUrl(generateQueryString(
      {
        ...queryParams,
        [PAGINATION_PARAM_NAMES.QUERY]: null,
      },
      {
        withPrefix: false,
        encode: false,
      },
    ), queryParams);

    if (queryString) {
      url += queryString;
    }
  }
  return url;
}

// @todo should be use hexToString function in stringUtils
function generateHex2a(hex) {
  let str = '';
  let i;
  if (hex.length > 0) {
    for (i = 0; i < hex.length; i += 2) {
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
  }
  return str;
}

function generateSplitString(text, splitedChar) {
  return text.split(splitedChar);
}

export {
  isSearchQueryParamsCorrectly,
  isSearchApiPaginationLimitExceeded,
  generateSearchPageFilterQueryParams,
  checkForSearchPageRedirection,
  generateSearchPageUrl,
  generateHex2a,
  generateSplitString,
}
